import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import {Home} from './pages/Home';
import Header from './components/Header';
import {Fashion} from './pages/Fashion';
import {Music} from './pages/Music';
import {About} from './pages/About';
import {Category} from './pages/Category';
import {ClubRiff} from './pages/ClubRiff';
import {RiffAi} from './pages/RiffAi';
import {Gallery} from './pages/Gallery';
import {Playlists} from './pages/Playlists';
import {Interviews} from './pages/Interviews';
import {WriteForUs} from './pages/WriteForUs';
import {Allarticles} from './pages/Allarticles';
import {ArtDesign} from './pages/ArtDesign';
import { Article } from './pages/Article';
import { RiffAiLoading } from "./pages/RiffAiLoading";
import { RiffAiResult }  from "./pages/RiffAiResult";

export function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/home" element={<Home />} />
        <Route path="/fashion" element={<Fashion />} />
        <Route path="/music" element={<Music />} />
        <Route path="/about" element={<About />} />
        <Route path="/category" element={<Category />} />
        <Route path="/clubriff" element={<ClubRiff />} />
        <Route path="/riffai" element={<RiffAi />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/playlists" element={<Playlists />} />
        <Route path="/interviews" element={<Interviews />} />
        <Route path="/writeforus" element={<WriteForUs />} />
        <Route path="/all-articles" element={<Allarticles />} />
        <Route path="/artdesign" element={<ArtDesign />} />
        <Route path="/articles/:id" element={<Article />} />
        <Route path="/riffai/loading" element={<RiffAiLoading />} />
        <Route path="/riffai/result/:slug" element={<RiffAiResult />} />
        <Route path="/riffai/result"  element={<RiffAiResult  />} />
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
    </Router>
  );
}
